<template>
  <span v-if="hasValue" class="price-badge">{{ formatted }}</span>
  <span v-else class="price-dash">—</span>
</template>

<script>
import { formatMoney } from '@/composables/subscriptionMeta.js';

export default {
  name: 'PriceBadge',
  props: {
    value: { type: [Number, String], default: null },
  },
  computed: {
    hasValue() {
      return this.value !== null && this.value !== undefined && this.value !== '';
    },
    formatted() {
      return formatMoney(this.value);
    },
  },
};
</script>
